import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
// import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AskToShowInfoDialogComponent } from 'src/components/ask-to-show-info-dialog/ask-to-show-info-dialog.component';
import { CheckoutDialogComponent } from 'src/components/checkout-dialog/checkout-dialog.component';
import { ChooseAvatarBottomsheetComponent } from 'src/components/choose-avatar-bottomsheet/choose-avatar-bottomsheet.component';
import { WebcamDialogComponent } from 'src/components/webcam-dialog/webcam-dialog.component';
import { ErrorReportService } from 'src/services/error-report.service';
import { GerencianetService } from 'src/services/gerencianet.service';
import { HttpService } from 'src/services/http.service';
import { OneSignalService } from 'src/services/onesignal.service';
import { TokenService } from 'src/services/token.service';
// import { PagseguroService } from 'src/services/pagseguro.service';
import { UploadService } from 'src/services/upload.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-customer-panel',
  templateUrl: './customer-panel.component.html',
  styleUrls: ['./customer-panel.component.scss']
})
export class CustomerPanelComponent implements OnInit {

  submiting: boolean = false;
  menu: Array<any> = new Array();
  isMobile$: Observable<any>;
  drawerOpen: boolean = false;
  user: any;
  @ViewChild('fileInput', { static: false }) private fileInput: ElementRef;
  @ViewChild('drawer', { static: false }) private drawer: MatSidenav;
  avatarPicture: string = null;
  progressUpload: number;
  isFlutterApp: boolean = false;

  constructor(
    private http: HttpService,
    private change: ChangeDetectorRef,
    private breakpoints: BreakpointObserver,
    private upload: UploadService,
    private errorReport: ErrorReportService,
    @Inject('MIDIA_ENDPOINT') private midiaEndpoint: string,
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private TokenService : TokenService,
    private oneSignalService: OneSignalService
    // private pagseguro: PagseguroService,
    // private gerencianet: GerencianetService,
    // private snackbar: MatSnackBar
  ) {

    this.isMobile$ = this.breakpoints
      .observe([Breakpoints.TabletPortrait, Breakpoints.Handset])
      .pipe(map(result => result.matches));

    this.menu = [
      {
        icon: 'fact_check',
        label: 'Processo seletivo',
        routerLink: ['user-process-list']
      },
      {
        icon: 'person',
        label: 'Dados pessoais',
        routerLink: ['profile']
      },
      {
        icon: 'description',
        label: 'Meu currículo',
        routerLink: ['curriculo']
      },
      {
        icon: 'work',
        label: 'Experiências profissionais',
        routerLink: ['experiences']
      },
      {
        icon: 'schooling',
        label: 'Escolaridade',
        routerLink: ['schooling']
      },
      // {
      //   icon: 'admin_panel_settings',
      //   label: 'Minha conta',
      //   click: () => {

      //     this.drawerOpen = false;
      //     var plano = this.user.company_id ? 'BUSINESS' : 'PERSONAL';

      //     if (plano == 'BUSINESS') {

      //       if (this.user.signature_id && this.user.signature_status === 'ACTIVE' && this.user.id)
      //         this.router.navigate(['/', 'customer', 'my-account'])
      //       else {
      //         const options = {
      //           disableClose: true,
      //           width: '600px'
      //         }
      //         this.dialog.open(CheckoutDialogComponent, options)
      //       }

      //     } else {
      //       this.router.navigate(['/', 'customer', 'my-account'])
      //     }

      //   }
      // }
    ]

  }

  ngOnInit(): void {

    this.http.getGlobalLoadingIndicator()
      .subscribe(
        result => {
          const { trigger } = result;
          this.submiting = trigger === 'pre';
          this.change.detectChanges();
        }
      )

    this.user = JSON.parse(localStorage.getItem('token'));
    const activeVoucher = localStorage.getItem('activeVoucher')

    this.getAvatar();

    var plano = this.user.company_id ? 'BUSINESS' : 'PERSONAL';

    if ((!this.user.signature_id || this.user.signature_status !== 'ACTIVE' || this.user.signature_status !== 'TRIAL') && !activeVoucher && plano == 'BUSINESS') {

      const options = {
        disableClose: true,
        width: '600px'
      }

      this.dialog.open(CheckoutDialogComponent, options)
        .afterClosed()
      // .subscribe(
      //   (result) => {
      //     if(!result)
      //       this.logout()
      //   }
      // )

    }

    const wObject = (window as any);
    wObject.addOnFlutterLoad(() => {
      this.isFlutterApp = true;
      wObject.setFlutterUploadEvent(() => this.getAvatar());
    })

    wObject.flutterTriggerEvent = (args) => {

      const { type, data } = args;
      if (type === 'drawer') {
        if (data)
          this.drawer.open();
        else this.drawer.close();
        this.drawerOpen = !this.drawerOpen
      }

    }
    
    if (!this.router.url.includes('/welcome')) {
      if (this.user.mostrar_experiencias == null) {
        this.getProfessional();
      }
    }

    try {
      this.oneSignalService.initOneSignal(); // Aguarde a inicialização
    } catch (error) {
      console.error('Error initializing OneSignal in component:', error);
    }

  }

  experiences
  getProfessional() {

    const params = {
      id: this.user.id,
      all: true
    }
    this.http.get('experience', params)
      .subscribe(
        (result: any) => {
          this.experiences = result.data.slice(0, 3);
          // console.log('Professional = '+this.experiences);
          this.getEducation();
        },
        (err: any) => {
          console.error(err);
        }
      )

  }

  educations
  getEducation() {

    const params = {
      id: this.user.id,
      all: true
    }
    this.http.get('education', params)
      .subscribe(
        (result: any) => {

          this.educations = result.data.slice(0, 3);
          //console.log('Education = '+this.experiences);

          const year = new Date(this.user.date_added).getFullYear();
          if (this.user.mostrar_experiencias == null && year <= 2022) {
            if (this.educations.length !== 0 && this.experiences.length !== 0) {
              this.dialog.open(
                AskToShowInfoDialogComponent,
                {
                  width: '600px',
                  disableClose: true
                }
              );
            }
          }

        },
        (err: any) => {
          console.error(err);
        }
      )

  }

  exitApp() {

    const wObject = (window as any);
    wObject.flutterExitApp();

  }

  logout() {

    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    localStorage.clear();
    setTimeout(() => window.location.reload(), 2000);

  }

  private getAvatar() {

    this.http.get('profile:avatar', { id: this.user.id }, null, true)
      .subscribe(
        (result: any) => {

          if (result.data.avatar_profile) {
            const uuid = uuidv4();
            this.avatarPicture = `${this.midiaEndpoint}${result.data.avatar_profile}?r=${uuid}`;
          }

        },
        err => this.errorReport.showMessage(err)
      )

  }

  openChooseFile() {
    this.bottomSheet.open(ChooseAvatarBottomsheetComponent)
      .afterDismissed()
      .subscribe(
        result => {

          const wObject = window as any;

          if (wObject.IS_FLUTTER) {

            const url = this.upload.getEndpoint();
            const getParams = {
              id: this.user.id,
              action: 'profile:avatar'
            };
            const postParams = {
              filename: 'avatar'
            }

            wObject.chooseImageAndUpload(result, url, postParams, getParams, null);

          } else {

            if (result === 'GALLERY')
              this.fileInput.nativeElement.click();
            else if (result === 'CAMERA') {

              const options = {
                width: '500px',
                disableClose: true
              }
              this.dialog.open(WebcamDialogComponent, options)
                .afterClosed()
                .subscribe(
                  (result: any) => {

                    if (result) {
                      this.avatarPicture = result.imageAsDataUrl;
                      this.beginUpload(result.imageBytes);
                    }
                  }
                )

            }

          }

        }
      )
  }

  changeAvatar(args) {

    const [file] = args.target.files;

    if (!file) return;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      const dataUrl = fileReader.result as string;
      this.avatarPicture = dataUrl;
    }
    fileReader.readAsDataURL(file);
    this.beginUpload(file);

  }

  private beginUpload(file) {

    const params = { id: this.user.id };
    const options = {
      reportProgress: true,
      observe: 'events'
    };

    this.upload.upload('profile:avatar', file, 'avatar', params, options)
      .subscribe(
        (event: HttpEvent<any>) => {

          switch (event.type) {
            case HttpEventType.UploadProgress:
              this.progressUpload = Math.round(event.loaded / event.total * 100);
              break;
            case HttpEventType.Response:
              setTimeout(() => this.progressUpload = 0, 500);
              const user = JSON.parse(localStorage.getItem('token'));
              user.avatar_profile = '/uploads/avatars/avatar_'+this.user.id+'.png';
              localStorage.setItem('token', JSON.stringify(user));
              break;
          }

        },
        err => this.errorReport.showMessage(err)
      );

      

  }

  onOpenedChange(opened) {

    const wObject = (window as any);
    if (opened) {
      wObject.setPushEvent({
        type: 'drawer',
        opened
      });
    } else {
      wObject.setPushEvent({
        type: 'url',
        data: null
      });
    }

  }

}
